var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLastPage = function SvgLastPage(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M6 17.6c-.2-.2-.3-.5-.3-.8s0-.6.3-.8l4-4-4-4a1 1 0 0 1-.3-.8c0-.3 0-.6.3-.8a1.1 1.1 0 0 1 1.6 0l4.8 4.8.3.4a1 1 0 0 1 0 .9l-.3.3-4.7 4.8-.9.3a1 1 0 0 1-.8-.3m11.3 1c-.4 0-.7-.2-.9-.4s-.3-.4-.3-.8V6.6c0-.3.1-.6.3-.8q.3-.3.9-.3c.3 0 .5 0 .8.3.2.2.3.5.3.8v10.8c0 .4-.1.6-.3.8-.3.2-.5.4-.8.4"
  })));
};
export default SvgLastPage;